import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { capabilityForRoute } from "@/components/route-acl-map";
import { getAccessSnapshot, hasCapability, readAccessSession } from "@/utils/accessControl";

const router = createRouter({
  history: createWebHistory(process.env.Base_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const capability = to.meta?.capability || capabilityForRoute(to.path);
  const session = readAccessSession();
  if (
    capability &&
    getAccessSnapshot(session).hasExplicitGrants &&
    !hasCapability(capability, session, { legacyDefault: false })
  ) {
    // A refused route is a permissions problem, not a missing page — send it to
    // the dedicated Access Denied view and pass the attempted path along so the
    // page can name it. Guard against redirecting to /403 from /403 itself.
    if (to.name === "AccessDeniedView") {
      next();
      return;
    }
    next({
      name: "AccessDeniedView",
      query: { from: to.fullPath },
      replace: true,
    });
    return;
  }
  document.title = to.meta.title
  next()
})

export default router
